import { Resolver } from 'react-hook-form';
import { recipient } from 'src/services/orderLink/orderLink.config';
import email from 'src/utils/validation/email';
import required from 'src/utils/validation/required';
import {
  validateFieldSync,
  validateFormSync,
} from 'src/utils/validation/validate-generators';

export const formResendEmailPayByLink = () => {
  const initialValues = {
    [recipient]: '',
  };

  const validate = validateFormSync({
    [recipient]: validateFieldSync(required, email),
  });

  const resolver: Resolver<any> = async (values: any) => {
    return {
      values: values,
      errors: validate(values),
    };
  };
  return { initialValues, resolver };
};
